/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SSRV2RuleListItem,
    SSRV2RuleListItemFromJSON,
    SSRV2RuleListItemFromJSONTyped,
    SSRV2RuleListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface SSRV2RuleListItemPaginationWrapper
 */
export interface SSRV2RuleListItemPaginationWrapper {
    /**
     * 
     * @type {Array<SSRV2RuleListItem>}
     * @memberof SSRV2RuleListItemPaginationWrapper
     */
    items?: Array<SSRV2RuleListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof SSRV2RuleListItemPaginationWrapper
     */
    totalItems?: number;
}

export function SSRV2RuleListItemPaginationWrapperFromJSON(json: any): SSRV2RuleListItemPaginationWrapper {
    return SSRV2RuleListItemPaginationWrapperFromJSONTyped(json, false);
}

export function SSRV2RuleListItemPaginationWrapperFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSRV2RuleListItemPaginationWrapper {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(SSRV2RuleListItemFromJSON)),
        'totalItems': !exists(json, 'totalItems') ? undefined : json['totalItems'],
    };
}

export function SSRV2RuleListItemPaginationWrapperToJSON(value?: SSRV2RuleListItemPaginationWrapper | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(SSRV2RuleListItemToJSON)),
        'totalItems': value.totalItems,
    };
}


